import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SportServicesService } from 'src/app/services/sport-service/sport-services.service';
import * as $ from 'jquery'
@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss']
})
export class CustomSelectComponent implements OnInit {
  @Input() labelName: string;
  @Input() placeholder: string;
  @Input() items: Array<any>;
  @Input() isRefreshing: boolean;
  @Input() seleteditem: any;
  @Input() width: any;
  @Input() id: any;
  @Input() key = 'name';
  @Input() error = {erc: '1', value: ''};
  @Input() emptyMessage: string;
  @Input() searchingItems: boolean;
  @Output() filterData: EventEmitter<any> = new EventEmitter();
  @Output() loadMore = new EventEmitter();
  @Output() itemChanged = new EventEmitter();
  @Output() refresh = new EventEmitter();
  searchdata = {
    filter: '',
    size: 50,
    page: 0
  };
  selectdiv: any;
  select: boolean;
  constructor(private sportService: SportServicesService) {
    this.sportService.subjectItem.subscribe(data => {
      if (data !== '') {
        this.searchdata.filter = data;
      }
    });
  }

  ngOnInit() {
    $('.custom-select').css('width', this.width )
    this.searchdata.filter = this.seleteditem
    this.setEvent({id:this.id, name: this.seleteditem})
  }

  filterEvents() {
    if (this.searchdata.filter.trim().length < 3 && this.searchdata.filter.length > 0) {
      return;
    } else {
      this.filterData.emit(this.searchdata);
    }
  }
  loadMoreEvents() {
    this.searchdata.page++;
    // console.log(this.searchdata)
    this.loadMore.emit(this.searchdata);

  }
  closeDropdown() {
    setTimeout(() => {
      if (!this.isRefreshing) {
        this.select = false;
      }
    }, 500);
  }
  openDropDown() {

    // this.selectdiv = $("input").width();
    $('.custom-select').css('width', this.width )
    // console.log(this.width);
    this.select = true;
  }
  setEvent(item) {
    // console.log(item);
    this.seleteditem = item;
    if (item.hasOwnProperty('id') && item.id.toString().includes('sr:tournament')) {
      this.searchdata.filter = item['category']['name'] + '-' + item[this.key] ;
    } else {
      this.searchdata.filter = item[this.key];
    }
    this.itemChanged.emit(this.seleteditem);

    this.select = false;
  }
  ngOnDestroy() {
    this.sportService.subjectItem.next('');
  }
}
